// eslint-disable-next-line import/prefer-default-export
export const LOCAL_STORAGE_MESSAGES_PAGE_NO = 'localStorageMessagesPageNo';
